<template>
  <step-section
    :title="$t('styleStepTitle')"
    :description="$t('styleStepDescription')"
    :step-number="getStepNumber('style')"
    :loading="loading$"
  >
    <div class="row row--custom">
      <div
        class="col-12 col-custom-line-6"
        v-for="item in styles"
        :key="item.id"
      >
        <style-block
          v-bind="item"
          :key="item.id"
          :checked="isItemChecked('style.id', item.id)"
          @click="() => handleItemClick(item)"
        />
      </div>
    </div>
  </step-section>
</template>

<script>
  import StyleBlock from '@/components/blocks/StyleBlock.vue';
  import stepMixin from './stepMixin';

  export default {
    name: 'StyleStep',
    mixins: [stepMixin],
    props: {
      styles: Array,
    },
    methods: {
      handleItemClick(style) {
        this.updateFormField({
          field: 'style',
          value: {
            id: style.id,
            name: style.name,
          },
        });
      },
    },
    components: {
      StyleBlock,
    },
  };
</script>
